import {Controller} from '@hotwired/stimulus'
import {Tooltip} from 'utils/bootstrap'

const SELECTOR = '[data-bs-toggle="tooltip"]'

export default class extends Controller {
  connect() {
    this.initTooltips(this.element)
    this.handleFrameLoad = (event) => this.initTooltips(event.target)
    this.handleBeforeFrameRender = (event) => this.constructor.disposeTooltips(event.target || document)

    document.addEventListener('turbo:frame-load', this.handleFrameLoad)
    document.addEventListener('turbo:before-frame-render', this.handleBeforeFrameRender)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad)
    document.removeEventListener('turbo:before-frame-render', this.handleBeforeFrameRender)
    this.constructor.disposeTooltips(this.element)
  }

  initTooltips(root) {
    const target = root || this.element || document
    target.querySelectorAll(SELECTOR).forEach((element) => {
      // An explicit data-bs-placement wins; Bootstrap 5 lets the config override it
      const placement = element.dataset.bsPlacement || 'auto'
      Tooltip.getOrCreateInstance(element, {placement})
    })
  }

  static disposeTooltips(frame) {
    // dispose any tooltip instances inside the frame about to be replaced
    frame.querySelectorAll(SELECTOR).forEach((element) => Tooltip.getInstance(element)?.dispose())
    // remove any leftover tooltip DOM nodes appended to body
    document.querySelectorAll('.tooltip').forEach((element) => element.remove())
  }
}
